<template>
  <div id="app">
    <view-cards v-if="view == 'DECKS'" @JoinGame="JoinGame"/>
    <arena v-if="view == 'ARENA'" :gameData="gameData"/>
  </div>
</template>

<script>
import ViewCards from './components/ViewCards.vue'
import Arena from './components/Arena.vue'
window.axios = require('axios');
export default {
  name: 'app',
  components: {
    ViewCards, Arena
  },
  data() {
    return {
      view: 'DECKS',
      gameData: null
    }
  },
  methods: {
    JoinGame(data) {
      this.gameData = data;
      this.view = 'ARENA';
    }
  }
}
</script>

<style>
.html, body {
  margin: 0px;
  padding: 0px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}
body, html, #app {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}
* {
  box-sizing: border-box;
}
</style>
